import styles from "./styles.module.scss";
import Section from "../../components/Section";
import img6 from "../../images/6.png";
import dsmax_icon from "../../graphics/3dsmax_icon.svg";

import design_1 from "../../images/design_1.png";
import design_2 from "../../images/design_2.png";
import design_3 from "../../images/design_3.png";

const Design = () => {
  return (
    <Section>
      <div className={styles.container}>
        <div className={styles.title}>
          <div>
            <img src={img6} alt="6" />
          </div>
          <h1>3D-ГРАФИКА</h1>
        </div>
        <div className={styles.content}>
          <div className={styles.col}>
            <div>
              <h4 className={styles.sub_title}>Задача</h4>
              <p className={styles.text}>
                Создание реалистичного интерьера спальни, используя современные
                текстуры, естественный свет и настройки камеры для рендера.
                <br />
                <br />
                Для разработки данной сцены использовались различные
                модификаторы для построения уникальных элементов, библиотеки
                компонентов и шаблоны для внедрения материалов.
              </p>
            </div>
            <div>
              <h4 className={styles.sub_title}>Реализация</h4>
              <div className={styles.logo_text}>
                <div>
                  <img src={dsmax_icon} alt="Figma" />
                </div>
                <p>3Ds Max</p>
              </div>
            </div>

            <div className={styles.images}>
              <div>
                <img src={design_2} alt="" />
              </div>
              <div>
                <img src={design_3} alt="" />
              </div>
            </div>
          </div>
          <div className={styles.image}>
            <img src={design_1} alt="" />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Design;
